import React, { lazy } from 'react';
const Booking = lazy(() => import("../../assets/js/react/components/booking/page/booking"));
import { CreateRoot } from '../../assets/js/react';
import { AppProvider } from '../../assets/js/react/components/booking/store';
import { IsPhysiqueAuthorized } from '../../assets/js/react/utils/auth';

const isAuth = IsPhysiqueAuthorized();
const hasMembership = !!localStorage.getItem('membershipId');
const membershipContainer = document.getElementById('membership-booking')?.querySelector('.container');
const func = !hasMembership || !isAuth ? 'remove' : 'add';
membershipContainer?.classList?.[func]('js-hide');

CreateRoot(
  'booking',
  <AppProvider>
    <Booking />
  </AppProvider>,
);
